import {Grid , Typography ,  Box ,  IconButton} from '@mui/material';
import '../App.css';


import LinkedInIcon from '@mui/icons-material/LinkedIn';

import GitHubIcon from '@mui/icons-material/GitHub';

import { HashLink as Link } from 'react-router-hash-link';


function Footer(){

    
   
    return(
        <Box style={{backgroundColor : '#2f3237' , marginTop : '4em'}} id="contact_me">
            <Grid container rowSpacing={2}  columnSpacing={1} style = {{marginTop : '4em' }}>
                <Grid item xs={12} marginTop='4em'>
                    <Typography variant="h5" component='div' 
                        style={{textAlign : 'center' , color : '#a08e63'}}
                    >
                        GET IN TOUCH
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography  component='div' 
                        style={{textAlign : 'center' , color : "white"}}
                    >
                        No matter what. Just do it
                    </Typography>
                </Grid>
                <Grid item xs={12} marginTop='-0.5em'>
                    <Typography  component='div' 
                        style={{textAlign : 'center' , color : "#706a4d" }}
                    >
                        nadir.med.mesmoudi@gmail.com
                    </Typography>
                </Grid>
                <Grid item xs={12} marginTop='3em' marginBottom='3em' style={{textAlign : 'center' , color:'white' }} >
                    <Link to='//www.github.com/nadircode' target='_blank'>
                        <IconButton 
                            aria-label="Github Account"
                            style={{
                            color : 'white' 
                            }}
                        >
                            <GitHubIcon style={{fontSize : '2em'}}/>
                        </IconButton>
                    </Link>
                    <Link to='//www.linkedin.com/in/nadir-mesmoudi' target='_blank'>
                        <IconButton 
                            aria-label="Github Account"
                            style={{
                            color : 'white' 
                            }}
                        >
                            <LinkedInIcon style={{fontSize : '2em'}}/>
                        </IconButton>
                    </Link>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Footer;